var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8995 19.0529C52.5705 16.3473 49.2998 15.2313 46.5941 16.5603C45.5105 17.0926 44.6339 17.9692 44.1016 19.0529L15.4725 77.3753C14.3526 79.6537 15.2916 82.4085 17.5699 83.5285C18.2018 83.8391 18.8967 84.0005 19.6008 84H78.4002C80.9389 84.0017 82.9983 81.945 83 79.4063C83.0005 78.7021 82.8392 78.0073 82.5285 77.3753L53.8995 19.0529ZM48 36C48.5523 36 49 36.4477 49 37V59C49 59.5523 48.5523 60 48 60C47.4477 60 47 59.5523 47 59V37C47 36.4477 47.4477 36 48 36ZM49 66C49 65.4477 48.5523 65 48 65C47.4477 65 47 65.4477 47 66C47 66.5523 47.4477 67 48 67C48.5523 67 49 66.5523 49 66Z",
    fill: "#FF6600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 64V64C47.5523 64 48 64.4477 48 65C48 65.5523 47.5523 66 47 66C46.4477 66 46 65.5523 46 65V65C46 64.4477 46.4477 64 47 64",
    fill: "#FF6600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58V36Z",
    fill: "#FF6600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58V36",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8995 15.0529V15.0529C50.5705 12.3473 47.2998 11.2313 44.5941 12.5603C43.5105 13.0926 42.6339 13.9692 42.1016 15.0529L13.4725 73.3753V73.3753C12.3526 75.6537 13.2916 78.4085 15.5699 79.5285C16.2018 79.8392 16.8967 80.0005 17.6008 80H76.4002V80C78.9389 80.0017 80.9983 77.945 81 75.4063C81.0005 74.7021 80.8392 74.0073 80.5285 73.3753L51.8995 15.0529Z",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5 19C71.3284 19 72 18.3284 72 17.5C72 16.6716 71.3284 16 70.5 16C69.6716 16 69 16.6716 69 17.5C69 18.3284 69.6716 19 70.5 19Z",
    stroke: "#FF6600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 88C18.3284 88 19 87.3284 19 86.5C19 85.6716 18.3284 85 17.5 85C16.6716 85 16 85.6716 16 86.5C16 87.3284 16.6716 88 17.5 88Z",
    fill: "#FF6600"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86 87H89",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M93 87H96",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91 89V92",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91 85V82",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8 23H13",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17 23H22",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15 25V30",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15 21V16",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e257dc1bec1609bc975c45ac73a677b8.svg";
export { ForwardRef as ReactComponent };